import React from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { loginUser } from "../store/authentication/actions";
import Loading from "../components/shared/Loader";
// import LoginLogo from "../assets/images/logo-white.png";
import { useEffect } from "react";

function Login({ logo }) {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.authentication);
  const navigate = useNavigate();

  useEffect(() => {
    if (error) {
      toast(error, { toastId: error });
    }
  }, [error]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    dispatch(loginUser({ data, navigate }));
  };
  if (loading) return <Loading />;

  return (
    <>
      <div className="login-wrp">
        <div className="login--inner">
          <div className="login-logo">
            <img src={logo} alt="" />
          </div>
          <div className="login-data">
            <h3>أهلا بعودتك</h3>
            <p> تسجيل الدخول</p>
          </div>
          <div className="login-form">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form-group">
                <input
                  {...register("email")}
                  className="form-control"
                  placeholder="البريد الإلكتروني"
                />
              </div>
              <div className="form-group">
                <input
                  type="password"
                  {...register("password")}
                  className="form-control"
                  placeholder="كلمة المرور"
                />
              </div>
              <div className="form-group">
                <button type="submit" className="btn btn-blue">
                  دخول
                </button>
              </div>
            </form>
            {errors.exampleRequired && <span>This field is required</span>}
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
